import * as React from 'react';

import { FinancialHeaders } from '../tableHeaders';

export type TableRowData = {
  [key: string]: any;
};

export interface CheckboxTableProps<T> {
  header: string[];
  data: T[];
  selectedRows: number[];
  currency?: string;
  onCheckboxChange: (index: number) => void;
  disabledRows?: number[];
  columnWidths?: string[];
  columnAlignments?: string[];
}

export const CheckboxTable = <T extends TableRowData>({
  header,
  data,
  selectedRows,
  currency,
  onCheckboxChange,
  disabledRows = [],
  columnWidths = [],
  columnAlignments = [],
}: CheckboxTableProps<T>) => {
  return (
    <table className="min-w-full table-auto rounded border border-separate">
      <thead className="bg-slate50">
        <tr>
          <th className="px-4 py-2" />
          {header.map((column, index) => {
            const alignmentClass = columnAlignments[index] ?? '';
            const widthClass = columnWidths[index] ?? '';
            const classNames = [alignmentClass, widthClass].filter(Boolean).join(' ');

            return (
              <th key={column} className={`px-4 py-2 ${classNames}`}>
                {column}
                {currency && FinancialHeaders.includes(column) ? ` (${currency})` : ''}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr key={index} className="bg-white">
            <td className="px-4 py-2">
              <input
                type="checkbox"
                checked={selectedRows.includes(index)}
                disabled={disabledRows.includes(index)}
                onChange={() => onCheckboxChange(index)}
              />
            </td>
            {header.map((column, colIndex) => {
              const alignmentClass = columnAlignments[colIndex] ?? '';
              const widthClass = columnWidths[colIndex] ?? '';
              const classNames = [alignmentClass, widthClass].filter(Boolean).join(' ');

              return (
                <td key={column} className={`px-4 py-2 ${classNames}`}>
                  {item[column]}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
